import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import usersService from './UsersService';
import { Pager } from '../templater/Pager';
import { FormGroup, Form, Input, Button } from 'reactstrap';

export class UsersList extends Component {
	constructor(props) {
		super(props);
		this.state = { users: [], page: 1, pageSize: 10, maxPages: 5, sortOrder: "Fname", searchString: "", loading: true };
	}

	componentDidMount() {
		this.populateUserData();
	}

	handlePageChange = (page) => {
		this.setState({ page: page }, () => this.populateUserData() );
	}

	handleHeaderClick = (event, header) => {
		event.preventDefault();

		let newSortOrder = this.state.sortOrder;

		switch (header) {
			case 'Fname': {
				newSortOrder = this.state.sortOrder === 'Fname' ? 'Fname_desc' : 'Fname';
				break;
			}
			case 'Lname': {
				newSortOrder = this.state.sortOrder === 'Lname' ? 'Lname_desc' : 'Lname';
				break;
			}
			case 'Email': {
				newSortOrder = this.state.sortOrder === 'Email' ? 'Email_desc' : 'Email';
				break;
			}
		}

		this.setState({ page: 1, sortOrder: newSortOrder }, () => this.populateUserData());
		return false;
	}

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({ [name]: value });
	}

	handleSearchFormSubmit = (event) => {
		event.preventDefault();
		this.populateUserData();
	}

	handleSearchFormReset = (event) => {
		event.preventDefault();
		this.setState({ page:1, searchString: "" }, () => this.populateUserData());
	}

	renderUsersTable() {
		const { users, totalUsers, sortOrder } = this.state;

		return (
			<div>
				<table className='table table-striped' aria-labelledby="tableLabel">
					<thead>
						<tr>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'Email')} >
									邮箱&nbsp;
									{sortOrder == 'Email' && <span>&#8897;</span>}
									{sortOrder == 'Email_desc' && <span>&#8896;</span>}
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'Fname')} >
									姓氏&nbsp;
									{sortOrder == 'Fname' && <span>&#8897;</span>}
									{sortOrder == 'Fname_desc' && <span>&#8896;</span>}
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'Lname')} >
									名字&nbsp;
									{sortOrder == 'Lname' && <span>&#8897;</span>}
									{sortOrder == 'Lname_desc' && <span>&#8896;</span>}
								</a>
							</th>
							<th >账号状态</th>
							<th />
						</tr>
					</thead>
					<tbody>
						{users.map(user =>
							<tr key={user.id}>
								<td>{user.email}</td>
								<td>{user.firstName}</td>
								<td>{user.lastName}</td>
								<td>{user.approved ? "已审核" : "待审核"}</td>
								<td>{user.approved ? <Link to={'/users/disabled/' + user.id}>禁用账号</Link> : <Link to={'/users/approve/' + user.id}>审核通过</Link>
								}</td>
								
							</tr>
						)}
					</tbody>
				</table>
				<Pager totalItems={totalUsers} page={this.state.page} pageSize={this.state.pageSize} maxPages={this.state.maxPages} handlePageChange={this.handlePageChange} />
			</div>
		);
	}

	render() {
		let contents = this.state.loading
			? <p><em>Loading...</em></p>
			: this.renderUsersTable();

		return (
			<div>
				<h1 id="tableLabel">待审核用户</h1>
				<Link to='/users/list/'>所有用户</Link>
				<Form inline onSubmit={this.handleSearchFormSubmit}>
					<FormGroup>
						<Input type="text" name="searchString" value={this.state.searchString} onChange={this.handleInputChange} placeholder="用户名或邮箱" />
					</FormGroup>&nbsp;
					<Button>搜索</Button>&nbsp;
					<Button onClick={this.handleSearchFormReset}>重置</Button>
				</Form><br/>
				{contents}
			</div>
		);
	}

	async populateUserData() {
		try {

			const data = await usersService.getAuditUsers(this.state.page, this.state.pageSize, this.state.sortOrder, this.state.searchString);
			this.setState({ totalUsers: data.totalUsers, users: data.users, loading: false });
		}
		catch (error) {
			// Handle error
		}
	}
}
